/* CÁENE Rebuy skin — DOM stabilizer + enrichment.
   Rebuy V2 wraps the cart in unclassed <div>s and lacks hooks for count-badge,
   prompt copy, or sub-labels. We tag wrappers + decorate the DOM from JS so
   CSS can target stable selectors. Re-runs via MutationObserver on every
   Rebuy re-render (cart-update, qty-change, gift-unlock, etc). */
(function () {
  'use strict';

  /* ── i18n (2026-07-24) ────────────────────────────────────────────
     Strängar injiceras per request-locale av theme.liquid som
     window.CAENE_CART_I18N (nycklar i locales/sv.json + en.default.json
     under caene.cart). Svenska fallbacks behålls här ifall objektet
     saknas (t.ex. cachad gammal theme.liquid). __PCT__ i subSave ersätts
     med procenttal i pillText(). root ("/", "/en/") prefixar drawer-länkar. */
  var I18N = window.CAENE_CART_I18N || {};
  // Liquids t-filter HTML-escapar & → "&amp;" i injektionen; dekoda här.
  function T(key, fallback) { return (I18N[key] || fallback).replace(/&amp;/g, '&'); }
  var IS_EN = String(I18N.locale || document.documentElement.lang || 'sv').toLowerCase().indexOf('en') === 0;
  var ROOT = I18N.root || '/';
  function localizePath(path) { return ROOT.replace(/\/$/, '') + path; }

  /* ── Cart-state cache ────────────────────────────────────────────
     Pill behöver veta om en line redan har selling_plan vid render.
     Rebuy re-renderar hela cart-DOM efter cart/change.js → den btn-
     referens vi satte "Prenumeration aktiv" på är detached. Den nya
     pillen som applyEnrichment() injicerar måste därför läsa state
     från en cache som uppdateras innan dispatch. Mikael 2026-05-18. */
  var CART_STATE = { byHandle: {}, lines: [], totalPrice: 0, itemCount: 0, hasFreeGift: false };
  function refreshCartState() {
    return fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (c) {
        var map = {};
        var lines = [];
        var hasFreeGift = false;
        (c.items || []).forEach(function (it) {
          var sp = it.selling_plan_allocation && it.selling_plan_allocation.selling_plan;
          // Behåll true om någon line för handle är sub (för dubbletter)
          if (!map[it.handle]) map[it.handle] = { hasSellingPlan: false };
          if (sp) {
            map[it.handle].hasSellingPlan = true;
            // F1/F6 (CRO 2026-07-28): plannamn + frekvens + kvantitet driver
            // frekvensraden + aktiv-pill-copyn. Recharge-planerna är byggda
            // qty-bundna (1/mån, 2/2mån, 3/3mån) men Shopify applicerar planen
            // oberoende av line-qty → copyn MÅSTE vara qty-medveten, annars
            // ljuger den ("3 påsar" på en qty-1-line). Verifierat 2026-07-29.
            map[it.handle].planName = sp.name || '';
            map[it.handle].unitPrice = it.final_price;
            map[it.handle].lineQty = it.quantity;
            var spOpts = sp.options || [];
            for (var oi = 0; oi < spOpts.length; oi++) {
              if (spOpts[oi].name === 'Order Frequency and Unit') map[it.handle].freqUnit = spOpts[oi].value;
              if (spOpts[oi].name === 'Product Quantity') map[it.handle].planQty = parseInt(spOpts[oi].value, 10);
            }
          }
          // FEL 3 (2026-07-30): per-rad-state nycklad på line.key — handle är
          // inte unik per cart-rad (sub + engång av samma produkt, två tier-
          // planer, två BYOB-kit med olika _trio_name). byHandle behålls för
          // aggregat (fraktnot, PILL_PCT); rad-bunden UI läser lines[].
          var line = {
            key: it.key,
            handle: it.handle,
            variantId: it.variant_id,
            hasSellingPlan: !!sp,
            planName: sp ? (sp.name || '') : '',
            unitPrice: it.final_price,
            lineQty: it.quantity,
            freqUnit: null,
            planQty: null,
            trioName: (it.properties && it.properties._trio_name) || null
          };
          if (sp) {
            var lOpts = sp.options || [];
            for (var li = 0; li < lOpts.length; li++) {
              if (lOpts[li].name === 'Order Frequency and Unit') line.freqUnit = lOpts[li].value;
              if (lOpts[li].name === 'Product Quantity') line.planQty = parseInt(lOpts[li].value, 10);
            }
          }
          // 0 kr-GWP-raden renderas inte som flyout-item → håll den utanför
          // lines[] så förekomst-mappningen DOM-rad→cart-rad inte förskjuts.
          if (it.final_line_price !== 0) lines.push(line);
          // Rebuy-GWP:n ligger som 0 kr-line → styr låsta gåvo-raden.
          if (it.final_line_price === 0) hasFreeGift = true;
          // Routine-widget-trios skickar _trio_name → cart-raden ska visa trions
          // namn ("hot girl summer") i stället för bundle-produktnamnet.
          if (it.properties && it.properties._trio_name) map[it.handle].trioName = it.properties._trio_name;
        });
        CART_STATE.byHandle = map;
        CART_STATE.lines = lines;
        CART_STATE.totalPrice = c.total_price || 0;
        CART_STATE.itemCount = c.item_count || 0;
        CART_STATE.hasFreeGift = hasFreeGift;
        enforcePlanTierGuard(c);
      })
      .catch(function () { /* swallow — next refresh will retry */ });
  }

  /* FEL 3: DOM-rad → cart-rad. Rebuy renderar cart.items i ordning men
     hoppar över 0 kr-gåvoraden (filtrerad ur lines[] ovan) → nyckla på
     n:te förekomsten av handlen. */
  function lineForRow(handle, occurrence) {
    var ls = CART_STATE.lines || [], seen = 0;
    for (var i = 0; i < ls.length; i++) {
      if (ls[i].handle !== handle) continue;
      if (seen === occurrence) return ls[i];
      seen++;
    }
    return null;
  }
  function lineByKey(key) {
    var ls = CART_STATE.lines || [];
    for (var i = 0; i < ls.length; i++) { if (ls[i].key === key) return ls[i]; }
    return null;
  }

  /* ── Tier-vakt (QA 2026-07-29, FEL 2) ────────────────────────────
     Rebuys qty-stepper ändrar line-qty utan att röra selling_plan →
     minus från qty 3 till 1 behåller qty-3-planen (25%, var 3:e mån)
     = prisläcka (224 kr/påse på en påse). Vakten re-mappar planen till
     högsta tier vars Product Quantity ≤ nya qty:n (qty 1 → månadsplan).
     Endast läck-riktningen (qty < planQty) åtgärdas — qty ÖVER tiern är
     ingen läcka och en tyst frekvensändring uppåt vore vilseledande.
     BYOB-bundlar saknar Product Quantity-option → skippas. Körs i varje
     refreshCartState (qty-events, drawer-open, page-load) → self-healing
     även för carts som läckte in före fixen. Busy-map per line-key
     stoppar dubbel-POST från parallella events; efter remap byter
     Shopify line-key → gammal flagga blir harmlös. */
  var TIER_GUARD_BUSY = {};
  function enforcePlanTierGuard(cart) {
    (cart.items || []).forEach(function (it) {
      var sp = it.selling_plan_allocation && it.selling_plan_allocation.selling_plan;
      if (!sp) return;
      var planQty = null;
      (sp.options || []).forEach(function (o) {
        if (o.name === 'Product Quantity') planQty = parseInt(o.value, 10);
      });
      if (!planQty || it.quantity >= planQty) return;
      if (TIER_GUARD_BUSY[it.key]) return;
      TIER_GUARD_BUSY[it.key] = true;
      fetch('/products/' + it.handle + '.js')
        .then(function (r) { return r.json(); })
        .then(function (p) {
          var plans = [];
          (p.selling_plan_groups || []).forEach(function (g) {
            (g.selling_plans || []).forEach(function (s) { plans.push(s); });
          });
          function qtyOf(plan) {
            var opts = (plan && plan.options) || [];
            for (var o = 0; o < opts.length; o++) {
              if (opts[o].name === 'Product Quantity') return parseInt(opts[o].value, 10);
            }
            return null;
          }
          var target = null;
          plans.forEach(function (plan) {
            var q = qtyOf(plan);
            if (q && q <= it.quantity && (!target || q > qtyOf(target))) target = plan;
          });
          if (!target || target.id === sp.id) return null;
          return fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: it.key, quantity: it.quantity, selling_plan: target.id })
          });
        })
        .then(function (res) {
          delete TIER_GUARD_BUSY[it.key];
          if (!res) return;
          // Rebuy plockar själv upp cart-ändringen (interceptar cart-API:t);
          // vi refreshar cachen + re-enrichar så pill/freq-rad visar nya planen.
          return refreshCartState().then(function () {
            document.dispatchEvent(new CustomEvent('rebuy:cart.refresh'));
          });
        })
        .catch(function () { delete TIER_GUARD_BUSY[it.key]; });
    });
  }

  /* ── Plan-copy-hjälpare (F1/F6, CRO 2026-07-28, rev 2026-07-29) ───
     Frekvens läses primärt från plan-OPTIONS ("Order Frequency and Unit" =
     1-month/2-month/3-month, finns i både cart.js- och product.js-planer),
     fallback namn-regex ("3 mån" etc; BYOB "Prenumeration – var 30:e dag"
     saknar frekvens-options → månadstext). Copyn är qty-medveten: "3 påsar
     var 3:e månad" sägs BARA när linjens qty faktiskt är ≥3 (PDP-tier 3);
     en qty-1-line med 3-mån-plan levererar 1 påse var 3:e månad — säg det. */
  function planFreqUnit(state) {
    if (!state) return '1-month';
    if (state.freqUnit) return state.freqUnit;
    if (/3\s*mån/i.test(state.planName || '')) return '3-month';
    if (/2\s*mån/i.test(state.planName || '')) return '2-month';
    return '1-month';
  }
  function activePillText(state) {
    var f = planFreqUnit(state);
    if (f === '3-month') return T('subActiveQuarterly', '3-månadersplan aktiv');
    if (f === '2-month') return T('subActiveBimonthly', '2-månadersplan aktiv');
    return T('subActive', 'Prenumeration aktiv');
  }
  function freqTextFor(state) {
    var f = planFreqUnit(state);
    var qty = (state && state.lineQty) || 1;
    var kr = Math.round(((state && state.unitPrice) || 0) / 100);
    if (f === '3-month') {
      if (qty >= 3) {
        return T('freqQuarterly', '3 påsar var 3:e månad · __KR__ kr/påse · pausa eller avsluta när du vill')
          .replace('__KR__', String(kr));
      }
      return T('freqEvery3m', 'Levereras var 3:e månad · pausa eller avsluta när du vill');
    }
    if (f === '2-month') {
      if (qty >= 2) return T('freqBimonthly', '2 påsar varannan månad · pausa eller avsluta när du vill');
      return T('freqEvery2m', 'Levereras varannan månad · pausa eller avsluta när du vill');
    }
    return T('freqMonthly', 'Levereras var 30:e dag · pausa, ändra eller avsluta när du vill');
  }

  /* F6-remap (Mikael 2026-07-29): cart-pillen applicerar MÅNADSPLANEN
     (Product Quantity = 1), INTE djupaste rabatten. 25/20%-planerna är
     qty-3/qty-2-tiers — applicerade på en qty-1-line gav de 1 påse var
     3:e månad till 25% = prisläcka + vilseledande copy (auditens F6,
     Recharge-verifierat via product.js options 2026-07-29). Djupare
     rabatt får man via PDP-tiers/BYOB där kvantiteten följer med planen. */
  function pickCartPlan(p, v) {
    var allocs = (v && v.selling_plan_allocations) || [];
    if (allocs.length === 0) return null;
    var groups = p.selling_plan_groups || [];
    var plans = [];
    for (var g = 0; g < groups.length; g++) {
      var gp = groups[g].selling_plans || [];
      for (var s = 0; s < gp.length; s++) plans.push(gp[s]);
    }
    function optOf(sp, name) {
      var opts = sp.options || [];
      for (var o = 0; o < opts.length; o++) { if (opts[o].name === name) return opts[o].value; }
      return null;
    }
    var chosen = null;
    for (var pi = 0; pi < plans.length; pi++) {
      if (optOf(plans[pi], 'Product Quantity') === '1') { chosen = plans[pi]; break; }
    }
    var alloc = null;
    if (chosen) {
      for (var a = 0; a < allocs.length; a++) {
        if (allocs[a].selling_plan_id === chosen.id) { alloc = allocs[a]; break; }
      }
    }
    if (!alloc) {
      // Ingen qty-1-plan (t.ex. BYOB-bundlar) → högsta-pris-allokeringen =
      // minsta rabatten = ingen läcka. För bundlar finns bara en plan.
      alloc = allocs.reduce(function (x, y) { return y.price > x.price ? y : x; });
      for (var pj = 0; pj < plans.length; pj++) {
        if (plans[pj].id === alloc.selling_plan_id) { chosen = plans[pj]; break; }
      }
    }
    return { alloc: alloc, plan: chosen, freqUnit: chosen ? optOf(chosen, 'Order Frequency and Unit') : null };
  }

  /* ── GWP-konfig (§G/T5, CRO 2026-07-28) ───────────────────────────
     Speglar Rebuy-GWP:n (gratis Desire ≥699 kr). Hårdkodat medvetet —
     Rebuys tier-config exponerar inte gåvo-produkten förrän den unlockas.
     Ändras GWP-kampanjen i Rebuy admin → uppdatera här. */
  var GWP_THRESHOLD_ORE = 69900;
  /* Speglar fri frakt-tiern i Rebuy-progressbaren — Rebuy admin exponerar
     inte tröskeln åt skin-koden. Ändras frakt-tiern → uppdatera här. */
  var FREE_SHIPPING_THRESHOLD_ORE = 44900;
  var GWP_TITLE = 'desire gummies';
  var GWP_IMG = 'https://cdn.shopify.com/s/files/1/0942/3329/7276/files/7340238713239_desire-03.jpg?v=1784644980&width=140';

  /* ── Pill-procent per handle (2026-07-21) ─────────────────────────
     Bundlar får MARKETING-procenten mot fullpris (3×299 resp 2×299) —
     matchar widget/BYOB-copy ("spara 30%"), inte allocation-procenten
     mot bundle-radpriset (12,53% vore tekniskt sant men fel claim).
     Övriga handles beräknas från djupaste selling plan-allocation
     (= den plan pill-klicket faktiskt applicerar) via lazy fetch. */
  var PILL_PCT = { byHandle: {
    'bygg-ditt-eget-3-pack': 30,
    'bygg-ditt-eget-2-pack': 25
  } };
  // F6 (rev 2026-07-29): planen pill-klicket applicerar = pickCartPlan()
  // (qty-1-planen, se nedan). PILL_PLAN cachar {name, freqUnit} för den —
  // driver pill-label så planbytet aldrig är tyst.
  var PILL_PLAN = { byHandle: {} };
  function pillText(handle) {
    var pct = handle && PILL_PCT.byHandle[handle];
    var plan = (handle && PILL_PLAN.byHandle[handle]) || null;
    if (plan && planFreqUnit({ freqUnit: plan.freqUnit, planName: plan.name }) === '3-month') {
      // Edge: produkt vars ENDA plan är 3-mån — visa plandetalj, inte bara %.
      return T('subSaveQuarterly', 'Spara __PCT__% — leverans var 3:e månad').replace('__PCT__', String(pct || 25));
    }
    return T('subSave', 'Prenumerera & spara __PCT__%').replace('__PCT__', String(pct || 15));
  }
  function ensurePillPct(handle) {
    if (!handle || PILL_PCT.byHandle[handle]) return;
    PILL_PCT.byHandle[handle] = 15; // pending-markör — förhindrar dubbelfetch
    fetch('/products/' + handle + '.js')
      .then(function (r) { return r.json(); })
      .then(function (p) {
        var v = p.variants && p.variants[0];
        var picked = pickCartPlan(p, v);
        if (!v || !picked) return;
        PILL_PCT.byHandle[handle] = Math.round(((v.price - picked.alloc.price) / v.price) * 100);
        PILL_PLAN.byHandle[handle] = { name: (picked.plan && picked.plan.name) || '', freqUnit: picked.freqUnit };
        // Synka redan renderade pills för handlen (ej aktiva)
        var pills = document.querySelectorAll('.caene-sub-pill[data-caene-product-handle="' + handle + '"]:not([data-active])');
        for (var i = 0; i < pills.length; i++) {
          if (pills[i].dataset.busy !== '1') pills[i].textContent = pillText(handle);
        }
      })
      .catch(function () { /* behåll fallback-procenten */ });
  }

  /* ── Cart-trigger interceptor — Mikael 2026-05-15 ─────────────────
     Hard-refresh på mobil + snabbt klick på cart-länken → Rebuys egen
     click-delegate inte bunden än → <a href="/cart"> navigerar till
     /cart-routen. Den sidan har "Laddar..."-state medan Recharge sync:ar
     cart-state → ser blank-vit ut tills items renderas. UX-fix: kapture
     klick på cart-trigger:s i capture-phase (innan Rebuy) och tvinga
     drawer-open. Om Rebuy inte ready än, vänta upp till 5s sen redirecta. */
  function interceptCartTriggers() {
    document.addEventListener('click', function (e) {
      var trigger = e.target.closest('.wt-cart__trigger, a[href="/cart"], a[href$="/cart"]');
      if (!trigger) return;
      // Tillåt cmd/ctrl/middle-click att öppna ny tab normalt
      if (e.metaKey || e.ctrlKey || e.shiftKey || e.button === 1) return;
      e.preventDefault();
      e.stopPropagation();
      function tryShow(attempts) {
        if (window.Rebuy && window.Rebuy.SmartCart && typeof window.Rebuy.SmartCart.show === 'function') {
          window.Rebuy.SmartCart.show();
          return;
        }
        if (attempts >= 50) {
          // 5s timeout — Rebuy laddade aldrig, fall tillbaka på navigation
          window.location.href = localizePath('/cart');
          return;
        }
        setTimeout(function () { tryShow(attempts + 1); }, 100);
      }
      tryShow(0);
    }, /* useCapture */ true);
  }
  if (document.body) {
    interceptCartTriggers();
  } else {
    document.addEventListener('DOMContentLoaded', interceptCartTriggers);
  }

  function tag(cartRoot) {
    var flyout = cartRoot.querySelector('.rebuy-cart__flyout');
    if (!flyout) return;

    var children = flyout.children;
    var headerWrap = null;
    for (var i = 0; i < children.length; i++) {
      if (children[i].querySelector('h2#rebuy-cart-title')) {
        headerWrap = children[i];
        break;
      }
    }
    if (!headerWrap) return;

    if (headerWrap.getAttribute('data-caene-zone') !== 'header') {
      headerWrap.setAttribute('data-caene-zone', 'header');
    }

    var subs = headerWrap.children;
    var progressSub = null;
    for (var j = 0; j < subs.length; j++) {
      var sub = subs[j];
      if (sub.querySelector('h2#rebuy-cart-title')) {
        if (sub.getAttribute('data-caene-sub') !== 'title') {
          sub.setAttribute('data-caene-sub', 'title');
        }
      } else if (
        sub.querySelector('.rebuy-cart__progress-bar-wrapper') ||
        sub.querySelector('.rebuy-cart__progress-step-wrapper') ||
        sub.querySelector('.rebuy-cart__progress-gifts')
      ) {
        if (sub.getAttribute('data-caene-sub') !== 'progress') {
          sub.setAttribute('data-caene-sub', 'progress');
        }
        progressSub = sub;
      }
    }

    // Tag bar-wrapper + step-wrapper for flexbox-ordering in CSS (sketch:
    // prompt → bar → labels). Rebuy default DOM order is steps→bar→prompt or
    // similar; tagging lets CSS reorder regardless of source order.
    if (progressSub) {
      var barWrap = progressSub.querySelector('.rebuy-cart__progress-bar-wrapper');
      if (barWrap && barWrap.getAttribute('data-caene-order') !== 'bar') {
        barWrap.setAttribute('data-caene-order', 'bar');
      }
      var stepWrap = progressSub.querySelector('.rebuy-cart__progress-step-wrapper');
      if (stepWrap && stepWrap.getAttribute('data-caene-order') !== 'steps') {
        stepWrap.setAttribute('data-caene-order', 'steps');
      }
    }
  }

  function enrich(cartRoot) {
    // 1. Count badge — circular pill prepended to title row (Lemme-pattern).
    //    Badge is a separate element, NOT appended to title text. Older skin
    //    ran "VARUKORG · N" inside the h2 — clean up legacy span if present.
    var titleRow = cartRoot.querySelector('[data-caene-sub="title"]');
    var titleEl = cartRoot.querySelector('h2#rebuy-cart-title');
    if (titleRow && titleEl) {
      var legacyCount = titleEl.querySelector('.caene-rebuy-count');
      if (legacyCount) legacyCount.remove();

      var count = 0;
      if (window.Shopify && window.Shopify.cart && typeof window.Shopify.cart.item_count === 'number') {
        count = window.Shopify.cart.item_count;
      } else {
        count = cartRoot.querySelectorAll('.rebuy-cart__flyout-item').length;
      }
      var existingBadge = titleRow.querySelector('.caene-rebuy-badge');
      if (count > 0) {
        if (existingBadge) {
          if (existingBadge.textContent !== String(count)) existingBadge.textContent = String(count);
        } else {
          var badge = document.createElement('div');
          badge.className = 'caene-rebuy-badge';
          badge.textContent = String(count);
          titleRow.insertBefore(badge, titleRow.firstChild);
        }
      } else if (existingBadge) {
        existingBadge.remove();
      }
    }

    // 2. Prompt copy rewrite — strip "Bara ", lowercase "FRI FRAKT", drop "!"
    var prompt = cartRoot.querySelector('.rebuy-cart__progress-bar-prompt');
    if (prompt) {
      var walker = document.createTreeWalker(prompt, NodeFilter.SHOW_TEXT, null);
      var node;
      while ((node = walker.nextNode())) {
        var t = node.nodeValue;
        var orig = t;
        t = t.replace(/^\s*Bara\s+/i, '');
        t = t.replace(/FRI FRAKT/gi, 'gratis frakt');
        t = t.replace(/!\s*$/, '');
        if (t !== orig) node.nodeValue = t;
      }
    }

    // 3. Step-label normalize (Lemme-pattern): drop "(...)" annotation, drop
    //    trailing "!", UPPERCASE → sentence-case. Preserve "CÁENE" as proper
    //    noun. Also strip any legacy .caene-rebuy-sub span left from older skin.
    var labels = cartRoot.querySelectorAll('.rebuy-cart__progress-step-label');
    for (var i = 0; i < labels.length; i++) {
      var lbl = labels[i];
      var legacySub = lbl.querySelector('.caene-rebuy-sub');
      if (legacySub) legacySub.remove();

      var t = (lbl.textContent || '').trim();
      // Idempotency — skip if already sentence-case w/o annotation/exclamation.
      // Allow CÁENE caps; check for OTHER uppercase 2+ runs.
      var stripped = t.replace(/CÁENE/g, '');
      if (!/[A-ZÅÄÖ]{2,}/.test(stripped) && !/\(/.test(t) && !/!\s*$/.test(t)) continue;

      t = t.replace(/\s*\(.+?\)\s*$/, '');
      t = t.replace(/!+\s*$/, '');
      t = t.toLowerCase();
      t = t.replace(/cáene/g, 'CÁENE');
      if (t.length > 0) t = t.charAt(0).toUpperCase() + t.slice(1);
      lbl.textContent = t.trim();
    }

    // 4. Product rows — Lemme-pattern decoration:
    //    a) Inject "Ta bort"-text into the remove-button (icon stays hidden via CSS)
    //    b) Wrap price + remove in [data-caene-row="meta"] so CSS can 2-col-grid them
    //    c) Add Subscribe & Save pill at end of info column, wired to selling_plan
    var items = cartRoot.querySelectorAll('.rebuy-cart__flyout-item');
    // FEL 3: DOM-rad → cart-rad via n:te förekomsten av handlen per render-svep.
    var seenHandles = {};
    for (var ix = 0; ix < items.length; ix++) {
      var row = items[ix];
      var info = row.querySelector('.rebuy-cart__flyout-item-info');
      var removeBtn = row.querySelector('.rebuy-cart__flyout-item-remove');
      var priceEl = row.querySelector('.rebuy-cart__flyout-item-price');
      var qtyEl = row.querySelector('.rebuy-cart__flyout-item-quantity');

      // a) "Ta bort"-text
      if (removeBtn && !removeBtn.querySelector('.caene-remove-label')) {
        var lbl = document.createElement('span');
        lbl.className = 'caene-remove-label';
        lbl.textContent = T('remove', 'Ta bort');
        removeBtn.appendChild(lbl);
      }

      // b) Meta-row wrapper — Lemme-pattern: [price] [cart_meta_label] [Ta bort]
      //    Label läses från window.CAENE_CART_LABELS (rendered av theme.liquid
      //    från product.metafields.custom.cart_meta_label). Fallback "60 gummies"
      //    om mappen saknas eller produkten inte har värde satt. Detta särskiljer
      //    bundles ("2x60 gummies") från singles ("60 gummies").
      var rowHandle = null;
      var rowTitleLink = row.querySelector('.rebuy-cart__flyout-item-product-title');
      if (rowTitleLink && rowTitleLink.getAttribute('href')) {
        var rowMatch = rowTitleLink.getAttribute('href').match(/\/products\/([^/?#]+)/);
        if (rowMatch) rowHandle = rowMatch[1];
      }
      var metaLabel = (window.CAENE_CART_LABELS && rowHandle && window.CAENE_CART_LABELS[rowHandle]) || T('metaFallback', '60 gummies');

      // FEL 3: rad-identitet = line.key (handle är inte unik per rad —
      // sub + engång av samma produkt, två tier-planer, två BYOB-kit).
      var rowOcc = 0;
      if (rowHandle) { rowOcc = seenHandles[rowHandle] || 0; seenHandles[rowHandle] = rowOcc + 1; }
      var rowLine = rowHandle ? lineForRow(rowHandle, rowOcc) : null;
      if (rowLine) row.setAttribute('data-caene-line-key', rowLine.key);

      // Trio-rader (routine-widget): visa trions namn i stället för
      // "Bygg ditt eget – 3-pack". Rad-bunden (FEL 3) — två kit med olika
      // _trio_name på samma handle får varsitt namn.
      var rowState = rowLine;
      if (rowState && rowState.trioName && rowTitleLink && rowTitleLink.textContent !== rowState.trioName) {
        rowTitleLink.textContent = rowState.trioName;
      }

      if (info && priceEl && removeBtn && !info.querySelector('[data-caene-row="meta"]')) {
        var meta = document.createElement('div');
        meta.setAttribute('data-caene-row', 'meta');
        info.insertBefore(meta, qtyEl || null);
        meta.appendChild(priceEl);
        var variantSpan = document.createElement('span');
        variantSpan.className = 'caene-meta-variant';
        variantSpan.textContent = metaLabel;
        meta.appendChild(variantSpan);
        meta.appendChild(removeBtn);
      }
      // Idempotency-fix: om meta-row redan finns men saknar variant, injicera.
      // Om variant finns men har fel text (t.ex. cached "60 gummies" på bundle),
      // uppdatera in-place.
      var existingMeta = info && info.querySelector('[data-caene-row="meta"]');
      if (existingMeta) {
        var existingVariant = existingMeta.querySelector('.caene-meta-variant');
        if (!existingVariant) {
          var variantSpan2 = document.createElement('span');
          variantSpan2.className = 'caene-meta-variant';
          variantSpan2.textContent = metaLabel;
          var existingRemove = existingMeta.querySelector('.rebuy-cart__flyout-item-remove');
          if (existingRemove) {
            existingMeta.insertBefore(variantSpan2, existingRemove);
          } else {
            existingMeta.appendChild(variantSpan2);
          }
        } else if (existingVariant.textContent !== metaLabel) {
          existingVariant.textContent = metaLabel;
        }
      }

      // c) Subscribe pill — wired to first selling_plan from product
      // Idempotency-fix: om pill redan finns (Rebuy partial-render), synca
      // dess text/data-active mot CART_STATE så cache-uppdateringar efter
      // initial render propageras till befintliga pill-noder.
      var existingPill = info && info.querySelector('.caene-sub-pill');
      if (existingPill && existingPill.dataset.busy !== '1') {
        var existingHandle = existingPill.getAttribute('data-caene-product-handle');
        // FEL 3: rad-bunden state (line.key), fallback via sparad key om
        // occurrence-mappningen missar (t.ex. mid-refresh).
        var existingState = rowLine || lineByKey(existingPill.getAttribute('data-caene-line-key'));
        if (rowLine) existingPill.setAttribute('data-caene-line-key', rowLine.key);
        var existingActive = !!(existingState && existingState.hasSellingPlan);
        var wantText = existingActive ? activePillText(existingState) : pillText(existingHandle);
        if (existingPill.textContent !== wantText) existingPill.textContent = wantText;
        if (existingActive) {
          existingPill.setAttribute('data-active', 'true');
        } else {
          existingPill.removeAttribute('data-active');
        }
      }
      if (info && !info.querySelector('.caene-sub-pill')) {
        var productHandle = null;
        var titleLink = row.querySelector('.rebuy-cart__flyout-item-product-title');
        if (titleLink && titleLink.getAttribute('href')) {
          var m = titleLink.getAttribute('href').match(/\/products\/([^/?#]+)/);
          if (m) productHandle = m[1];
        }
        var pill = document.createElement('button');
        pill.type = 'button';
        pill.className = 'caene-sub-pill';
        pill.setAttribute('data-caene-product-handle', productHandle || '');
        // FEL 3: pillen bär radens line.key → klick-handlern muterar EXAKT
        // den rad kunden klickade på (variant_id-find träffade första raden).
        pill.setAttribute('data-caene-line-key', rowLine ? rowLine.key : '');
        // State-aware initial render — cache populeras i refreshCartState()
        // före varje cart-dispatch. Förhindrar default-text-flash efter
        // Rebuys post-toggle re-render (gamla pill-noden är då detached).
        var pillState = rowLine;
        var isSubActive = !!(pillState && pillState.hasSellingPlan);
        if (isSubActive) {
          pill.textContent = activePillText(pillState);
          pill.setAttribute('data-active', 'true');
        } else {
          pill.textContent = pillText(productHandle);
          ensurePillPct(productHandle);
        }
        info.appendChild(pill);

        if (productHandle) {
          pill.addEventListener('click', function (handle, btn) {
            return function (e) {
              e.preventDefault();
              if (btn.dataset.busy === '1') return;
              // Toggle-mode — läs state vid click-time. data-active="true"
              // betyder linjen är sub aktiv → klick = unsubscribe. Tidigare
              // körde handler:n alltid subscribe-path → andra klick blev
              // no-op POST (samma selling_plan), Rebuy re-renderade tillbaka
              // pill med samma text → upplevdes som "laddar men inget händer".
              // Mikael 2026-05-18.
              var wasActive = btn.getAttribute('data-active') === 'true';
              btn.dataset.busy = '1';
              btn.textContent = '…';
              fetch('/products/' + handle + '.js')
                .then(function (r) { return r.json(); })
                .then(function (p) {
                  return fetch('/cart.js').then(function (r) { return r.json(); }).then(function (c) {
                    // FEL 3 (2026-07-30): nyckla på line.key från raden vi
                    // klickade på. variant_id-find() träffade FÖRSTA raden med
                    // varianten → sub-raden muterades när engångsraden klickades.
                    var lineKey = btn.getAttribute('data-caene-line-key');
                    var line = lineKey ? c.items.filter(function (it) { return it.key === lineKey; })[0] : null;
                    if (!line) throw new Error('line not in cart');
                    var v = p.variants.filter(function (x) { return x.id === line.variant_id; })[0] || p.variants[0];
                    // F6-remap (2026-07-29): qty-1-planen (månadsplanen), inte
                    // djupaste rabatten — se pickCartPlan-kommentaren.
                    var picked = wasActive ? null : pickCartPlan(p, v);
                    if (!wasActive && !picked) throw new Error('no selling plan');
                    if (picked) {
                      PILL_PLAN.byHandle[handle] = { name: (picked.plan && picked.plan.name) || '', freqUnit: picked.freqUnit };
                    }
                    return fetch('/cart/change.js', {
                      method: 'POST',
                      headers: { 'Content-Type': 'application/json' },
                      // Shopify Ajax Cart API kräver quantity vid line-change.
                      // Utan den svarar live 400 och pillen fastnar i laddningsläge.
                      body: JSON.stringify({
                        id: line.key,
                        quantity: line.quantity,
                        selling_plan: wasActive ? null : picked.alloc.selling_plan_id
                      })
                    }).then(function (res) {
                      if (!res.ok) throw new Error('cart change failed: ' + res.status);
                      return res;
                    });
                  });
                })
                .then(function () {
                  // Cache MÅSTE refreshas FÖRE Rebuys re-render — annars
                  // ser ny pill default-state och blinkar tillbaka till
                  // "Prenumerera & spara 25%" trots att linjen är sub.
                  return refreshCartState().then(function () {
                    document.dispatchEvent(new CustomEvent('rebuy:cart.refresh'));
                    // FEL 5 (2026-07-30): setCartAsync() anropades utan cart-arg
                    // och med truthy- i stället för typeof-guard → TypeError i
                    // varje pill-toggle. Anropet är redundant — Rebuy interceptar
                    // cart-API:t och rebuy:cart.refresh ovan driver re-rendern
                    // (samma mönster som tier-vakten, e2e-verifierad).
                    // Optimistic update på nuvarande btn-referens (om fortfarande
                    // attached). Re-render kommer ändå plocka rätt state via cache.
                    if (wasActive) {
                      btn.textContent = pillText(handle);
                      btn.removeAttribute('data-active');
                    } else {
                      // Nyapplicerad plan = pickCartPlan-valet → cachad i PILL_PLAN.
                      var appliedPlan = PILL_PLAN.byHandle[handle];
                      btn.textContent = activePillText(appliedPlan ? { planName: appliedPlan.name, freqUnit: appliedPlan.freqUnit } : null);
                      btn.setAttribute('data-active', 'true');
                    }
                    btn.dataset.busy = '';
                  });
                })
                .catch(function () {
                  // Revert till state vi FÖRSÖKTE lämna — om subscribe failade
                  // var linjen one-time, om unsubscribe failade var den sub.
                  if (wasActive) {
                    btn.textContent = activePillText(lineByKey(btn.getAttribute('data-caene-line-key')) || CART_STATE.byHandle[handle]);
                    btn.setAttribute('data-active', 'true');
                  } else {
                    btn.textContent = pillText(handle);
                    btn.removeAttribute('data-active');
                  }
                  btn.dataset.busy = '';
                });
            };
          }(productHandle, pill));
        } else {
          pill.disabled = true;
        }
      }

      // d) F1 (CRO 2026-07-28): frekvensrad under sub-lines — "vad binder
      //    jag mig till?" besvaras i beslutsögonblicket. Visas ENDAST när
      //    linjen har selling plan; text per plantyp (månad/kvartal) från
      //    CART_STATE. Signatur-attribut gör injektionen idempotent OCH
      //    låter EN-rewritern översätta utan att nästa enrich resettar.
      var lineState = rowLine; // FEL 3: rad-bunden — sub+engång av samma produkt får varsin korrekt rad
      var wantFreq = !!(info && lineState && lineState.hasSellingPlan);
      var freqEl = info && info.querySelector('.caene-freq-row');
      if (wantFreq) {
        var freqSig = (lineState.planName || '') + '|' + (lineState.freqUnit || '') + '|' + (lineState.lineQty || '') + '|' + (lineState.unitPrice || '') + '|' + (lineState.key || '');
        if (!freqEl) {
          freqEl = document.createElement('div');
          freqEl.className = 'caene-freq-row';
          freqEl.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" aria-hidden="true"><path d="M21 12a9 9 0 1 1-2.6-6.4"/><path d="M21 3v6h-6"/></svg><span class="caene-freq-text"></span>';
          info.appendChild(freqEl);
        }
        if (freqEl.getAttribute('data-caene-freq-sig') !== freqSig) {
          freqEl.setAttribute('data-caene-freq-sig', freqSig);
          freqEl.querySelector('.caene-freq-text').textContent = freqTextFor(lineState);
        }
      } else if (freqEl) {
        freqEl.parentNode.removeChild(freqEl);
      }
    }

    // 5b. Compare-at-price hammer — inline font-size 13px + nowrap.
     //     Differentierar struken-priset från huvudpriset via STORLEK istället
     //     för weight — storlek är robustare än att jaga Rebuys font-weight-
     //     selectors. Detekterar struken text via computed text-decoration så
     //     vi inte är beroende av Rebuys klassnamn (som de byter mellan v-bumps).
     var priceBlocks = cartRoot.querySelectorAll('.rebuy-cart__flyout-item-price, .rebuy-cart__flyout-subtotal-amount');
     for (var pb = 0; pb < priceBlocks.length; pb++) {
       priceBlocks[pb].style.setProperty('white-space', 'nowrap', 'important');
       var spans = priceBlocks[pb].querySelectorAll('*');
       for (var sp = 0; sp < spans.length; sp++) {
         var cs = window.getComputedStyle(spans[sp]);
         if (cs && cs.textDecorationLine && cs.textDecorationLine.indexOf('line-through') !== -1) {
           spans[sp].style.setProperty('font-size', '13px', 'important');
           spans[sp].style.setProperty('white-space', 'nowrap', 'important');
         }
       }
     }

    // 5c. Cross-sell CTA-text — Rebuy levererar "LÄGG TILL"/"KÖP" i versaler.
    //     Vi vill matcha sub-pill-stilen (mixed-case "Prenumerera & spara 25%").
    //     CSS text-transform: none räcker inte eftersom källtexten ÄR uppercase.
    //     Mapping är explicit (case-insensitive) så vi inte råkar lowercase:a
    //     framtida CTA-varianter ("Snabb-byt" etc). Idempotent — kollar att
    //     texten ändå inte är rätt innan write.
    var ctas = cartRoot.querySelectorAll('.rebuy-button');
    var ctaMap = { 'LÄGG TILL': T('add', 'Lägg till'), 'KÖP': T('buy', 'Köp'), 'ADD': T('add', 'Lägg till'), 'BUY': T('buy', 'Köp') };
    for (var cx = 0; cx < ctas.length; cx++) {
      var btn = ctas[cx];
      // Bevara icon-children och endast byt text-nod
      var nodes = btn.childNodes;
      for (var nx = 0; nx < nodes.length; nx++) {
        var n = nodes[nx];
        if (n.nodeType === 3) {
          var raw = (n.nodeValue || '').trim();
          if (ctaMap[raw.toUpperCase()] && n.nodeValue.indexOf(ctaMap[raw.toUpperCase()]) === -1) {
            n.nodeValue = n.nodeValue.replace(raw, ctaMap[raw.toUpperCase()]);
          }
        }
      }
    }

    // 5. Tier tick-marks: compute % position of each intermediate threshold
    //    (e.g. shipping 499kr / gift 699kr = 71.39%) and expose as CSS custom
    //    prop so meter::after can paint a "snitt" at that point.
    if (window.Rebuy && window.Rebuy.SmartCart && window.Rebuy.SmartCart.progressBar) {
      var tiers = window.Rebuy.SmartCart.progressBar.tiers || [];
      if (tiers.length >= 2) {
        var lastMin = tiers[tiers.length - 1].minimum;
        if (lastMin && lastMin > 0) {
          for (var t = 0; t < tiers.length - 1; t++) {
            var pct = (tiers[t].minimum / lastMin) * 100;
            cartRoot.style.setProperty('--cn-tier-' + (t + 1) + '-pct', pct.toFixed(2) + '%');
          }
        }
      }
    }

    // 6. F1 (CRO 2026-07-28): fraktrad under totalen — tar bort
    //    överraskningskostnaden i sista beslutssteget. Frakt 49/fri ≥449
    //    speglar Rebuy-tier + FAQ. F4-beslut (Mikael 2026-07-29):
    //    garantimeningen länkar till refund-policyn där villkoren
    //    (första köpet, en gång per kund) står — [T1]-flaggan löst.
    var subtotalBlock = cartRoot.querySelector('.rebuy-cart__flyout-subtotal');
    if (subtotalBlock) {
      var ship = subtotalBlock.querySelector('.caene-shipping-note');
      if (!ship) {
        ship = document.createElement('div');
        ship.className = 'caene-shipping-note';
        var shipText = document.createElement('span');
        shipText.className = 'caene-shipping-note__shipping';
        ship.appendChild(shipText);
        ship.appendChild(document.createTextNode(' '));
        var guaranteeLink = document.createElement('a');
        guaranteeLink.className = 'caene-shipping-note__guarantee';
        guaranteeLink.href = localizePath('/policies/refund-policy');
        guaranteeLink.textContent = T('guaranteeNote', '30 dagars nöjd-garanti.');
        ship.appendChild(guaranteeLink);
        subtotalBlock.appendChild(ship);
      }
      // Prenumeration = alltid fri frakt (fraktregeln speglar Rebuy-
      // progressbaren, som checkar av "Gratis frakt" så fort en sub ligger
      // i carten oavsett total). Engångsköp: tröskel-dynamisk 49/fri ≥449.
      // data-ship-state gör uppdateringen idempotent så EN-rewriten (körs
      // efter) inte skrivs över i onödan.
      var cartHasSub = false;
      for (var sh in CART_STATE.byHandle) {
        if (CART_STATE.byHandle[sh].hasSellingPlan) { cartHasSub = true; break; }
      }
      var shipState = (cartHasSub || CART_STATE.totalPrice >= FREE_SHIPPING_THRESHOLD_ORE) ? 'free' : 'paid';
      if (ship.getAttribute('data-ship-state') !== shipState) {
        ship.setAttribute('data-ship-state', shipState);
        ship.querySelector('.caene-shipping-note__shipping').textContent = shipState === 'free'
          ? T('shippingNoteFree', 'Fri frakt.')
          : T('shippingNote', 'Frakt 49 kr — fri över 449 kr.');
      }
      // Nöjd-garantin gäller enbart prenumerationer (policy-beslut Mikael
      // 2026-07-29, refund-policyn omskriven samma dag) — länken visas bara
      // när minst en line har selling plan, annars lovar vi engångsköpare
      // en garanti de inte har.
      ship.querySelector('.caene-shipping-note__guarantee').style.display = cartHasSub ? '' : 'none';
    }

    // 7. §G/T5 (CRO 2026-07-28): GWP som produktrad efter sista line-item —
    //    gåvan syns i själva korgen, inte bara i progress-arean. Två lägen:
    //    LÅST (total < 699 → "låses upp vid 699 kr") och UPPLÅST (total ≥ 699
    //    eller 0 kr-line i cart → "nu gratis"-rad med bock). Raden är gåvans
    //    ENDA representation i drawern: Rebuy lägger 0 kr-linen i cart.js vid
    //    tröskeln men renderar den ALDRIG som flyout-item (bara i progress-
    //    arean, som skinnet döljer) — utan permanent rad syns gåvan först i
    //    checkout (verifierat 2026-07-29: cart.js hade Desire 0 kr, flyout
    //    saknade den). Tröskel-checken (inte bara hasFreeGift) täcker Rebuys
    //    add-lag; gift-adden muterar inte flyout-DOM:en så ingen re-render
    //    är garanterad när linen väl landar.
    var gwpEl = cartRoot.querySelector('.caene-gwp-row');
    var gwpItems = cartRoot.querySelectorAll('.rebuy-cart__flyout-item');
    var wantGwp = gwpItems.length > 0 && CART_STATE.totalPrice > 0;
    var gwpUnlocked = CART_STATE.hasFreeGift ||
      CART_STATE.totalPrice >= GWP_THRESHOLD_ORE;
    if (wantGwp && !gwpEl) {
      gwpEl = document.createElement('div');
      gwpEl.className = 'caene-gwp-row';
      gwpEl.innerHTML =
        '<img src="' + GWP_IMG + '" alt="" loading="lazy">' +
        '<div class="caene-gwp-body">' +
          '<div class="caene-gwp-title">' + GWP_TITLE +
            '<svg class="caene-gwp-lock" viewBox="0 0 24 24" width="13" height="13" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><rect x="5" y="11" width="14" height="9" rx="2"/><path d="M8 11V7a4 4 0 0 1 8 0v4"/></svg>' +
            '<svg class="caene-gwp-check" viewBox="0 0 24 24" width="13" height="13" fill="none" stroke="currentColor" stroke-width="2.5" aria-hidden="true"><path d="M20 6L9 17l-5-5"/></svg>' +
          '</div>' +
          '<div class="caene-gwp-note"></div>' +
        '</div>' +
        '<div class="caene-gwp-price"><span class="caene-gwp-free">0 kr</span><span class="caene-gwp-was">299 kr</span></div>';
      gwpItems[gwpItems.length - 1].parentNode.appendChild(gwpEl);
    } else if (!wantGwp && gwpEl) {
      gwpEl.parentNode.removeChild(gwpEl);
      gwpEl = null;
    }
    if (gwpEl) {
      // Lägesväxling varje render — tröskeln kan passeras åt båda håll
      // (qty-stepper, ta bort-länk) med raden kvar i DOM.
      gwpEl.classList.toggle('caene-gwp-row--unlocked', gwpUnlocked);
      // KRITISK GUARD (2026-07-30): textContent-sättning ersätter textnoden
      // ÄVEN när strängen är identisk → childList-mutation → vår egen
      // MutationObserver → nytt enrichment-pass → oändlig loop @60fps med
      // en cart.js-fetch per varv → Shopify 429:ar kunden (verifierat med
      // mutation-spy: 542 replace på 5 s, enda muterande posten). Skriv
      // ENDAST vid faktisk ändring — samma mönster som pill/freq-raden.
      var gwpNoteEl = gwpEl.querySelector('.caene-gwp-note');
      var gwpNoteText = gwpUnlocked
        ? T('gwpNoteUnlocked', 'Din gåva — nu gratis i din varukorg')
        : T('gwpNote', 'Din gåva — låses upp vid 699 kr');
      if (gwpNoteEl.textContent !== gwpNoteText) gwpNoteEl.textContent = gwpNoteText;
    }

    // 8. §G (CRO 2026-07-28): betaltrust-badges under CHECKOUT — risk-
    //    reducering i sista steget. Riktiga betalloggor (Mikael 2026-07-30) från
    //    #caene-pay-icons-templaten i cart-skin-css.liquid (Shopifys officiella
    //    payment_type_svg_tag-ikoner); text-pills bara som fallback om templaten
    //    saknas. Swish utgick — finns inte bland butikens betalmetoder.
    var checkoutBtn = cartRoot.querySelector('.rebuy-cart__checkout-button');
    if (checkoutBtn && checkoutBtn.parentNode && !cartRoot.querySelector('.caene-pay-row')) {
      var payRow = document.createElement('div');
      payRow.className = 'caene-pay-row';
      var payIconTpl = document.getElementById('caene-pay-icons');
      if (payIconTpl && payIconTpl.content && payIconTpl.content.querySelector('svg')) {
        payRow.appendChild(payIconTpl.content.cloneNode(true));
      } else {
        var payMethods = ['Shop Pay', 'Klarna', 'VISA', 'Mastercard', 'G Pay'];
        for (var pm = 0; pm < payMethods.length; pm++) {
          var badge = document.createElement('span');
          badge.className = 'caene-pay-badge';
          badge.textContent = payMethods[pm];
          payRow.appendChild(badge);
        }
      }
      checkoutBtn.insertAdjacentElement('afterend', payRow);
    }
  }

  // Observer-state — module-scope så re-runs delar samma referens.
  var lastCartNode = null;
  var innerObserver = null;
  var rafToken = null;

  /* Settle-recheck (GWP-race 2026-07-29): Rebuys tier-gåva läggs till/tas
     bort i cart.js EFTER att drawern re-renderat — och muterar inte flyout-
     DOM:en (gåvan renderas aldrig som flyout-item). Sista enrichment kör
     alltså på stale CART_STATE och gåvo-radens läge fastnar (låst vid 897 kr
     / "nu gratis" vid 299 kr — båda observerade). En engångs-omsync efter
     att Rebuy hunnit klart fångar efterslängen. Coalesced — bara sista
     triggern i en burst schemalägger. */
  var settleToken = null;
  function scheduleSettleRecheck() {
    if (settleToken) clearTimeout(settleToken);
    settleToken = setTimeout(function () {
      settleToken = null;
      refreshCartState().then(function () {
        var cart = document.getElementById('rebuy-cart');
        if (cart) applyEnrichment(cart);
      });
    }, 2500);
  }

  /* Empty-cart CTA-stack — Mikael 2026-05-18 (spec
     docs/superpowers/specs/2026-05-18-empty-cart-redesign-design.md).
     När #rebuy-cart har class `no-items`: byt sub-copy + injecta
     2 outline-pillar. Idempotent — re-runs vid varje Rebuy-render. */
  var EMPTY_CTAS = [
    { label: T('ctaBuildRitual', 'Bygg din ritual'), href: localizePath('/pages/byob') },
    { label: T('ctaShopAll', 'Shoppa allt'),         href: localizePath('/collections/all-products') }
  ];

  var EMPTY_SUB_COPY = T('emptySub', 'Börja bygg din CÁENE-rutin nedan.');

  function injectEmptyCtas(cart) {
    if (!cart.classList.contains('no-items')) {
      var stale = cart.querySelector('[data-caene-empty-ctas]');
      if (stale) stale.parentNode.removeChild(stale);
      return;
    }

    var host = cart.querySelector('.rebuy-cart__flyout-empty-cart');
    if (!host) return;

    var subs = host.querySelectorAll('p.ql-align-center');
    for (var s = 0; s < subs.length; s++) {
      if (subs[s].querySelector('a')) continue;
      if (subs[s].textContent.trim() !== EMPTY_SUB_COPY) {
        subs[s].textContent = EMPTY_SUB_COPY;
      }
      break;
    }

    if (host.querySelector('[data-caene-empty-ctas]')) return;

    var wrap = document.createElement('div');
    wrap.setAttribute('data-caene-empty-ctas', '');

    for (var i = 0; i < EMPTY_CTAS.length; i++) {
      var cta = EMPTY_CTAS[i];
      var a = document.createElement('a');
      a.className = 'caene-empty-cta';
      a.href = cta.href;
      a.textContent = cta.label;
      wrap.appendChild(a);
    }

    host.appendChild(wrap);
  }

  /* ── EN-rewrite av Rebuy-levererad svensk copy (2026-07-24) ──────
     Rebuy-admin är enspråkig (svensk/engelsk mix i config) och följer inte
     Shopify-locale. På /en skriver vi därför om den finita strängmängden
     (drawer-titel, tier-prompts, badges, subtotal, empty-markup, login,
     cross-sell-rubriker) EFTER sv-normaliseringen i enrich(). Exakta
     källsträngar enumererade från Rebuy.SmartCart.settings live 2026-07-24.
     Körs sist i applyEnrichment, endast när IS_EN. Idempotent — översatta
     noder matchar inte längre de svenska nycklarna. */
  var EN_EXACT = {
    'Varukorg': 'Cart',
    'Gratis frakt': 'Free shipping',
    'gratis frakt': 'free shipping',
    'Gratis CÁENE gummies': 'Free CÁENE gummies',
    'Gratis Gåva': 'Free gift',
    'Gratis Gåva!': 'Free gift!',
    'Varukorgen är tom': 'Your cart is empty',
    'Lägg till dina favorit gummies till din varukorg': 'Add your favorite gummies to your cart',
    'SHOPPA': 'SHOP',
    'Logga in': 'Log in',
    'Mitt konto': 'My account',
    'PARAS MED': 'PAIRS WITH',
    'BOOSTA UPP MED DESSA': 'BOOST IT WITH THESE',
    // Rebuy levererar cross-sell-CTA:er som <span>Lägg till</span> —
    // spans är inte direkta textnoder i .rebuy-button så ctaMap i enrich()
    // missar dem; walkern här fångar dem i stället.
    'Lägg till': 'Add',
    'Köp': 'Buy',
    // CRO 2026-07-28 Förslag B — F1/F6/§G-strängar (injicerade av skin.js
    // med svenska fallbacks; nya I18N-nycklar finns inte i locales än).
    // F4 2026-07-29: garantin är egen länk-nod → två separata textnoder.
    'Frakt 49 kr — fri över 449 kr.': 'Shipping 49 kr — free over 449 kr.',
    'Fri frakt.': 'Free shipping.',
    '30 dagars nöjd-garanti.': '30-day satisfaction guarantee.',
    'Levereras var 30:e dag · pausa, ändra eller avsluta när du vill': 'Ships every 30 days · pause, edit or cancel anytime',
    'Din gåva — låses upp vid 699 kr': 'Your gift — unlocks at 699 kr',
    '3-månadersplan aktiv': '3-month plan active',
    '2-månadersplan aktiv': '2-month plan active',
    'Levereras var 3:e månad · pausa eller avsluta när du vill': 'Ships every 3 months · pause or cancel anytime',
    'Levereras varannan månad · pausa eller avsluta när du vill': 'Ships every 2 months · pause or cancel anytime',
    '2 påsar varannan månad · pausa eller avsluta när du vill': '2 pouches every 2 months · pause or cancel anytime'
  };
  var EN_PATTERNS = [
    [/🎉\s*Grattis! Du har fått\s*/g, '🎉 You have unlocked '],
    [/^\s*Du är bara\s+(.+?)\s+från att få\s+(.+?)\s+gratis\s*!?\s*$/, 'Only $1 to a free $2'],
    [/^\s*(.+?)\s+är nu gratis i din varukorg\s*!?\s*$/, '$1 is now free in your cart'],
    [/^\s*Totalt \((\d+) produkter\)\s*$/, 'Total ($1 items)'],
    [/^\s*Totalt \((\d+) produkt\)\s*$/, 'Total ($1 item)'],
    [/\bkvar till\b/g, 'to'],
    // CRO 2026-07-28 — dynamiska F1/F6-strängar (procent/pris varierar)
    [/^Spara (\d+)% — leverans var 3:e månad$/, 'Save $1% — ships every 3 months'],
    [/^3 påsar var 3:e månad · (\d+) kr\/påse · pausa eller avsluta när du vill$/, '3 pouches every 3 months · $1 kr\/pouch · pause or cancel anytime']
  ];
  function rewriteRebuyEnglish(cartRoot) {
    if (!IS_EN) return;
    var walker = document.createTreeWalker(cartRoot, NodeFilter.SHOW_TEXT, null);
    var node;
    while ((node = walker.nextNode())) {
      var raw = node.nodeValue;
      if (!raw || !/[a-zA-ZåäöÅÄÖ]/.test(raw)) continue;
      var trimmed = raw.trim();
      if (EN_EXACT.hasOwnProperty(trimmed)) {
        node.nodeValue = raw.replace(trimmed, EN_EXACT[trimmed]);
        continue;
      }
      var t = raw;
      for (var p = 0; p < EN_PATTERNS.length; p++) {
        t = t.replace(EN_PATTERNS[p][0], EN_PATTERNS[p][1]);
      }
      if (t !== raw) node.nodeValue = t;
    }
    // Rebuys empty-markup länkar till sv-rot ("/collections/all") —
    // prefixa med locale-root så /en-besökare stannar i engelska butiken.
    var emptyLinks = cartRoot.querySelectorAll('.rebuy-cart__flyout-empty-cart a[href^="/"]');
    for (var a = 0; a < emptyLinks.length; a++) {
      var href = emptyLinks[a].getAttribute('href');
      if (href.indexOf('/en/') !== 0 && href !== '/en') {
        emptyLinks[a].setAttribute('href', localizePath(href));
      }
    }
  }

  function applyEnrichment(cart) {
    tag(cart);
    enrich(cart);
    injectEmptyCtas(cart);
    rewriteRebuyEnglish(cart);
  }

  function run() {
    var cart = document.getElementById('rebuy-cart');
    if (!cart) return false;

    // Re-attach inner observer om Rebuy har bytt ut #rebuy-cart-noden
    // (Vue unmount/remount). Annars observerar vi en detached node och
    // får aldrig re-fire på nya renders → drawer öppnas tom.
    if (cart !== lastCartNode) {
      if (innerObserver) innerObserver.disconnect();
      lastCartNode = cart;
      innerObserver = new MutationObserver(function () {
        // Settle-schemat måste ligga UTANFÖR rAF-gaten: rAF fryser i dold
        // tab (visibilitychange) medan setTimeout tickar — annars fastnar
        // gåvo-raden i fel läge tills tabben fokuseras igen.
        scheduleSettleRecheck();
        // rAF-coalesce — Rebuy spammar flera mutations per render
        if (rafToken) return;
        rafToken = requestAnimationFrame(function () {
          rafToken = null;
          // Sync render direkt så användaren ser något utan vänta.
          applyEnrichment(cart);
          // Async cache-refresh sen re-enrich — säkerställer att pill
          // visar rätt sub-state även när stale cache vid första render.
          refreshCartState().then(function () { applyEnrichment(cart); });
        });
      });
      innerObserver.observe(cart, { childList: true, subtree: true });
    }

    applyEnrichment(cart);
    return true;
  }

  // Polling fallback — om #rebuy-cart inte finns vid load, försök igen
  // varje 500ms upp till 30s. Gamla init() gav upp efter 1 retry → tyst död.
  var pollAttempts = 0;
  function poll() {
    if (run()) return;
    if (++pollAttempts >= 60) return;
    setTimeout(poll, 500);
  }

  function start() {
    poll();
    // Initial cache-load så pill får rätt state vid första render om
    // användaren redan har sub-aktiv linje i cart från tidigare session.
    refreshCartState().then(function () { run(); });

    // Lyssna på Rebuy-events för explicit re-run vid cart-update / drawer-open.
    // Catchar fall där Rebuy re-mounta:r #rebuy-cart utan att inner observer
    // hinner reagera (t.ex. cart sync efter login).
    var events = [
      'rebuy.smartcart.opened',
      'rebuy.smartcart.refresh',
      'rebuy.smartcart.update',
      'rebuy.cart.update',
      'rebuy.cart.changed',
      'rebuy:cart.refresh',
      'rebuy:smartcart.opened',
      // Theme-events från egna widgets (routine-widget m.fl.) som ATC:ar
      // in-place utan sidladdning. Utan dessa missas enrichment när Rebuy
      // remountar #rebuy-cart efter add (observer på detached node,
      // rad utan pill/trio-titel). Verifierat 2026-07-21.
      'cart:added',
      'cart:refresh'
    ];
    for (var e = 0; e < events.length; e++) {
      document.addEventListener(events[e], function () {
        // Synca cache först → kör enrich med fresh state. Catchar qty-
        // change, gift-unlock m.m. som triggar re-render utan att vår
        // pill-handler är inblandad.
        refreshCartState().then(function () { run(); });
        scheduleSettleRecheck();
      });
    }
  }

  if (document.body) {
    start();
  } else {
    document.addEventListener('DOMContentLoaded', start);
  }
})();
/* re-register 2026-05-14T14:00 — cart_meta_label från metafält + idempotent update */
